export default __webpack_public_path__ + "static/media/Expiringshortly.937bc42e.svg";